import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios"
import { toast } from "react-toastify"

import baseURL from "utils/base-url"
import { history, pushWithBasePath } from "./App"

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
})

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token: string | null = localStorage.getItem("ahli_token") || null

  let headers = config.headers ?? {}

  if (token) headers.Authorization = `Bearer ${token}`

  return {
    ...config,
    headers,
  }
})

instance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.code === "ERR_NETWORK") {
      toast.error("Server error!")
    } else if (
      error.response?.status === 403 &&
      (error.response?.data as any)?.title === "License is expired."
    ) {
      toast.error("License is expired!")
      localStorage.removeItem("ahli_token")
      pushWithBasePath("/login")
    } else if (
      error.response?.status === 403 ||
      error.response?.status === 406
    ) {
      localStorage.removeItem("ahli_token")
      pushWithBasePath("/login")
    }

    return Promise.reject(error)
  },
)

export const request = instance
export default request
